<mat-form-field appearance="fill">
  <mat-label>Select Report</mat-label>
  <mat-select matNativeControl  (selectionChange)="onValueChange($event)" required>
    <mat-option value="Document">Document Wise Productivity</mat-option>
    <mat-option value="Discipline">Discipline Wise Productivity</mat-option>
    <mat-option value="Member">Member Wise Productivity</mat-option>   
  </mat-select>
</mat-form-field>


<div class="eip-pt-10 eip-pb-10">
  <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
    [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
  </ssrs-reportviewer>
</div>
